import React, {Component} from 'react';
import {Menu, Icon} from 'semantic-ui-react';

export class TopLevel extends Component {
  render() {
    const {name, active, baseClass, isExpandable} = this.props;
    let expandIcon = <Icon name={active ? 'angle down' : 'angle right'} />;
    return (
      <Menu.Item
        onClick={() => this.props.handleClick()}
        as="a"
        active={!isExpandable && active}
        href={'#' + name}
        title={name}
        className={baseClass}
      >
        <React.Fragment>
          <b>{name}</b>
          {isExpandable && expandIcon}
        </React.Fragment>
      </Menu.Item>
    );
  }
}

export default TopLevel;
